import { createReducer, on } from '@ngrx/store';
import { AuthActions } from '../auth/auth.actions';
import { UserActions } from './user.actions';
import { GhUserProfileDto } from '../../api/generated/administration/models/gh-user-profile-dto';

export type UserStatus = 'idle' | 'loading' | 'success' | 'error';

export type UserState = {
  profile: GhUserProfileDto | null;
  status: UserStatus;
  error: string | null;
  lastSyncedAt: string | null;
};

export const initialUserState: UserState = {
  profile: null,
  status: 'idle',
  error: null,
  lastSyncedAt: null,
};

export const userReducer = createReducer(
  initialUserState,
  on(AuthActions.initializeSucceeded, (state, { profile, profileSyncedAt }) => ({
    ...state,
    profile,
    status: profile ? ('success' as const) : ('idle' as const),
    error: null,
    lastSyncedAt: profileSyncedAt,
  })),
  on(AuthActions.loginSucceeded, (state, { profile, profileSyncedAt }) => ({
    ...state,
    profile,
    status: 'success' as const,
    error: null,
    lastSyncedAt: profileSyncedAt,
  })),
  on(UserActions.loadProfileRequested, (state) => ({
    ...state,
    status: 'loading' as const,
    error: null,
  })),
  on(UserActions.loadProfileSucceeded, (state, { profile, syncedAt }) => ({
    ...state,
    profile,
    status: 'success' as const,
    error: null,
    lastSyncedAt: syncedAt,
  })),
  on(UserActions.loadProfileFailed, (state, { error }) => ({
    ...state,
    status: 'error' as const,
    error,
  })),
  on(
    UserActions.reset,
    AuthActions.sessionCleared,
    AuthActions.refreshFailed,
    AuthActions.loginFailed,
    AuthActions.initializeFailed,
    () => initialUserState,
  ),
);
